
import React, { Component } from "react";
import styled, {css} from "styled-components";
import TableCell from "@material-ui/core/TableCell";
import { blue } from "@material-ui/core/colors";
import { DateTimeDisplay } from "core/Display";


const StyledPoints = styled.ul`
  margin: 0;
  padding: 0 0 0 18px;
  list-style: disc;
  
  li {
    margin-bottom: 4px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledPoint = styled.div`
  .time {
    font-size: 12px;
    color: #828282;
    white-space: nowrap;
  }
  .name {
    text-overflow: ellipsis;
  }
  .place {
    font-size: 12px;
    color: #828282;
  }
  .place-status {
    font-size: 12px;
    font-weight: bold;
  }
  
  .span-margin-box {
    word-break: break-all;
    
    span {
      margin-right: 10px;
    }
    
    span:last-child {
      margin-right: 0;
    }
  }
`;

const StyledPointName = styled.span`
  ${props => props.isColored === true && css`
    color: ${blue[600]};
  `}
`;


class OrderPoint extends Component {
  render() {
    const { orderPoint, hasPointsDate } = this.props;
    return (
      <li>
        <StyledPoint>
          {hasPointsDate && (
            <div style={{height: '15px', lineHeight: '12px'}} className={'span-margin-box'}>
              {orderPoint.date && (
                <span className={'time'}><DateTimeDisplay value={orderPoint.date} format={'DD.MM HH:mm'} /></span>
              )}
            </div>
          )}
          <div className={'name'}>
            <StyledPointName isColored={orderPoint.point.distance && orderPoint.point.distance > 150}>{orderPoint.point.name}</StyledPointName>
            {orderPoint.status && (
              <>
                {' '}
                <span className={'point-status'} style={{color: orderPoint.status.color}}>
                  {orderPoint.status.name}
                </span>
              </>
            )}
          </div>
          <div className={'span-margin-box'}>
            {orderPoint.point_text && <span className={'place'}>{orderPoint.point_text}</span>}
          </div>
        </StyledPoint>
      </li>
    )
  }
}


export default class TableCellPoints extends Component {
  render() {
    const { item } = this.props;
    if (item.points === null) {
      return <TableCell />
    }
    const hasPointsDate = item.points.filter(p => p.date !== null).length > 0;
    return (
      <TableCell>
        <StyledPoints>
          {item.points.map((point) =>
            <OrderPoint
              key={point.id}
              order={item}
              orderPoint={point}
              hasPointsDate={hasPointsDate}
            />
          )}
        </StyledPoints>
      </TableCell>
    )
  }
}
